<template>
  <div
    :class="{
      'opacity-50 cursor-not-allowed': inProgress || (ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2')
    }"
  >
    <h2 class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b">
      Informations
    </h2>
    <form
      autocomplete="off"
      name="submitInvestor"
      v-on:submit.prevent="submitInvestor()"
    >
      <div class="flex my-8 max-w-md">
        <div class="flex-1 px-4 py-2">
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('firstname')"
            >{{
              getFieldMsgError("firstname") ||
                $t("team.firstname") + " " + $t("form.required")
            }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('firstname') ? 'has-error input' : ''"
            theme="team"
            name="firstname"
            v-model="form.firstname"
            :label="$t('team.firstname')"
            :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            :required="true"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('lastname')"
            >{{
              getFieldMsgError("lastname") ||
                $t("team.lastname") + " " + $t("form.required")
            }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('lastname') ? 'has-error input' : ''"
            theme="team"
            name="lastname"
            v-model="form.lastname"
            :label="$t('team.lastname')"
            :required="true"
            :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
          ></sp-input>
          <div class="form-control relative mt-3">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('birth_date')"
              >{{
                getFieldMsgError("birth_date") ||
                  $t("team.birthDate") + " " + $t("form.required")
              }}</span
            >
            <label
              class="date-required block text-blue text-2sm font-bold mb-3"
              >{{ $t("team.birthDate") }}</label
            >
            <flat-picker
              v-model="form.birth_date"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
              placeholder="Date de naissance"
              :config="{ dateFormat: 'Y-m-d' }"
              :class="
                validateFieldError('birth_date')
                  ? 'has-error-date border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight'
                  : 'border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight'
              "
            ></flat-picker>
          </div>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('email')"
            >{{
              getFieldMsgError("email") ||
                $t("team.email") + " " + $t("form.required")
            }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('email') ? 'has-error input' : ''"
            theme="team"
            name="email"
            v-model="form.email"
            :label="$t('team.email')"
            :required="true"
            :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
          ></sp-input>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="validateFieldError('phone')"
            >{{
              getFieldMsgError("phone") ||
                $t("team.phone") + " " + $t("form.required")
            }}</span
          >
          <sp-input
            class="mt-3"
            :class="validateFieldError('phone') ? 'has-error input' : ''"
            theme="team"
            name="phone"
            v-model="form.phone"
            :label="$t('team.phone')"
            :required="true"
            :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
          ></sp-input>

          <div class="form-control relative mb-5">
            <label class="block text-blue text-2sm font-bold mb-3">{{
              $t("team.isYouTn")
            }}</label>
            <sp-radio
              theme="team"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
              v-model="form.is_tunisian"
              v-for="(op, index) in [
                { name: 'Oui', value: true },
                { name: 'Non', value: false }
              ]"
              :key="index"
              :value="op.value"
              :name="'radio' + index"
              :id="'radio' + index"
              >{{ op.name }}</sp-radio
            >
          </div>
          <span
            class="text-sm block sm:inline text-left text-red-dark py-3"
            v-if="
              (validateFieldError('country')) &&
                !form.is_tunisian
            "
            >{{
              getFieldMsgError("country") ||
                $t("team.country") + " " + $t("form.required")
            }}</span
          >

          <div v-if="!form.is_tunisian" class="form-control relative mt-3">
            <sp-select-country
              v-model="form.country"
              :class="
                validateFieldError('country') && !form.is_tunisian ? 'has-error checkmark' : ''
              "
              :selected="form.country"
              theme="team"
              label="Sélectionnez votre pays de nationalité"
              placeholder="Sélectionner"
              :required="true"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-select-country>
          </div>

          <div class="form-control relative">
            <div
              v-if="invalidfield"
              class="border border-red-light text-sm text-red-dark px-4 py-3 mb-4 rounded relative"
              role="alert"
            >
              <ul
                class="error-messages block sm:inline text-left p-0 list-reset"
              >
                <li>{{ errorMessage }}</li>
              </ul>
            </div>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="
                validateFieldError('cin_number') && form.is_tunisian
              "
              >{{
                getFieldMsgError("cin_number") ||
                  $t("team.cinNumber") + " " + $t("form.required")
              }}</span
            >
            <sp-input
              class="mt-3"
              :class="
                validateFieldError('cin_number') && form.is_tunisian ? 'has-error input' : ''
              "
              v-if="form.is_tunisian"
              theme="team"
              v-model="form.cin_number"
              name="cin_number"
              id="cin_number"
              :label="$t('team.cinNumber')"
              :required="true"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-input>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('passeport_number') && form.is_tunisian == false"
              >{{
                getFieldMsgError("passeport") ||
                  $t("team.passportNumber") + " " + $t("form.required")
              }}</span
            >
            <sp-input
              class="mt-3"
              :class="
                validateFieldError('passeport_number') && form.is_tunisian == false
                  ? 'has-error input'
                  : ''
              "
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
              v-if="!form.is_tunisian"
              theme="team"
              v-model="form.passeport_number"
              name="passeport_number"
              id="passeport_number"
              :label="$t('team.passportNumber')"
              :required="true"
            ></sp-input>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('cin_file') && form.is_tunisian"
              >{{
                getFieldMsgError("cin_file") ||
                  $t("team.cin_file_required") + " " + $t("form.required")
              }}</span
            >
            <sp-dropzone
              class="mt-3"
              :class="
                validateFieldError('cin_file') && form.is_tunisian
                  ? 'has-error .dropzone.vue-dropzone'
                  : ''
              "
              v-if="form.is_tunisian"
              theme="team"
              id="cin"
              :cinFile="form.cin_file"
              :url="url"
              :label="$t('team.cinUpload')"
              :required="true"
              :vdropzonesuccess="dropzoneSuccess"
              :vdropzoneError="vdropzoneError"
              type="0"
              acceptedFiles="application/pdf"
              :vdropzone-removed-file="vdropzoneRemovedFile"
              :vdropzoneProcessing="vdropzoneProcessing"
              :maxFiles="maxFiles"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-dropzone>
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="
                (validateFieldError('passeport_file') && form.is_tunisian == false) ||
                  passportFileError
              "
              >{{
                getFieldMsgError("passeport_file") ||
                  $t("team.passeport_file_required") + " " + $t("form.required")
              }}</span
            >
            <sp-dropzone
              class="mt-3"
              :class="
                (validateFieldError('passeport_file') && form.is_tunisian == false) ||
                passportFileError
                  ? 'has-error .dropzone.vue-dropzone'
                  : ''
              "
              v-if="!form.is_tunisian"
              theme="team"
              id="passport"
              :passportFile="form.passeport_file"
              :url="url"
              :label="$t('team.cinPasseport')"
              :required="true"
              :vdropzonesuccess="dropzoneSuccess"
              :vdropzoneError="vdropzoneError"
              type="0"
              acceptedFiles="application/pdf"
              :vdropzone-removed-file="vdropzonePassportRemovedFile"
              :vdropzoneProcessing="vdropzoneProcessing"
              :maxFiles="maxFiles"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-dropzone>
          </div>
          <div class="form-control relative mt-3">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('quality')"
              >{{
                getFieldMsgError("quality") ||
                  "Qualité" + " " + $t("form.required")
              }}</span
            >
            <sp-select
              class="mt-3"
              :class="validateFieldError('quality') ? 'has-error input' : ''"
              theme="team"
              name="quality"
              v-model="form.quality"
              label="Qualité"
              :options="qualityList"
              :selected="form.quality"
              :required="true"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-select>
          </div>
          <div class="form-control relative mt-3">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('adress')"
              >{{
                getFieldMsgError("adress") ||
                  "Adresse" + " " + $t("form.required")
              }}</span
            >
            <sp-input
              class="mt-3"
              :class="validateFieldError('adress') ? 'has-error input' : ''"
              theme="team"
              name="adress"
              v-model="form.adress"
              :label="'Adresse'"
              :required="true"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-input>
          </div>
          <div class="form-control relative mt-3">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('city')"
              >{{
                getFieldMsgError("city") || "Ville" + " " + $t("form.required")
              }}</span
            >
            <sp-input
              class="mt-3"
              :class="validateFieldError('city') ? 'has-error input' : ''"
              theme="team"
              name="city"
              v-model="form.city"
              :label="'Ville'"
              :required="true"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-input>
          </div>
          <div class="form-control relative mt-3">
            <span
              class="text-sm block sm:inline text-left text-red-dark py-3"
              v-if="validateFieldError('postal_code')"
              >{{
                getFieldMsgError("postal_code") ||
                  "Code Postal" + " " + $t("form.required")
              }}</span
            >
            <sp-input
              class="mt-3"
              :class="validateFieldError('postal_code') ? 'has-error input' : ''"
              theme="team"
              name="postal_code"
              v-model="form.postal_code"
              :label="'Code Postal'"
              :required="true"
              :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'"
            ></sp-input>
          </div>
        </div>
      </div>
      <div
        class="flex items-center justify-end w-auto bg-white shadow-box mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
      >
        <sp-button
          theme="outline-blue"
          space="small"
          type="submit"
          :disabled="
            inProgress ||
              (ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2')
          "
          >{{ $t("team.save") }}</sp-button
        >
        <sp-button
          v-if="this.$route.params.ecoAppId"
          theme="blue"
          space="small"
          type="submit"
          name="next"
          :disabled="
            inProgress ||
              (ecosystemApp &&
                ecosystemApp.application &&
                ecosystemApp.application.status != '0' &&
                ecosystemApp.application.status != '2')
          "
          @click="next()"
        >{{ $t("form.nextTeam")}}</sp-button>
      </div>
    </form>
  </div>
</template>
<script>
import { ValidationProvider } from "vee-validate";
import DropZoneVue from "../../components/spKit/DropZone.vue";
import InputVue from "../../components/spKit/Input.vue";
import TextareaVue from "../../components/spKit/Textarea.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import Link from "@/components/spKit/Link.vue";
import flatPickr from "vue-flatpickr-component";
import Select from "@/components/spKit/Select.vue";
import "flatpickr/dist/flatpickr.css";
import { SAVE_INVESTOR_FORM, CREATE_ECOSYSTEM_APP } from "@/store/actions.type";
import { mapGetters, mapState } from "vuex";

import { API_URL } from "@/common/config";
import CheckboxVue from "../../components/spKit/Checkbox.vue";
const uploadURL = API_URL + "/documents/upload";
import SelectCountryVue from "../../components/spKit/selectCountry/SelectCountry.vue";
import RadioVue from "../../components/spKit/Radio.vue";
export default {
  name: "PyicalPersonForm",
  props: {
    type: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: false
    },
    application: {
      type: Object,
      required: false
    }
  },
  components: {
    ValidationProvider,
    "sp-dropzone": DropZoneVue,
    "sp-input": InputVue,
    "sp-textarea": TextareaVue,
    "sp-button": ButtonVue,
    "sp-link": Link,
    "flat-picker": flatPickr,
    "sp-checkbox": CheckboxVue,
    "sp-select-country": SelectCountryVue,
    "sp-select": Select,
    "sp-radio": RadioVue
  },
  data() {
    return {
      canSubmit: false,
      passportFileError: false,
      url: uploadURL,
      maxFiles: 1,
      inProgress: false,
      isSubmitted: false,
      invalidfield: "",
      fileUpload: [],
      passportFileUplaod: [],
      errors: [],
      teamErrors: [],
      form: {
        firstname: null,
        lastname: null,
        birth_date: null,
        email: null,
        cin_number: null,
        cin_file: null,
        passeport_number: null,
        passeport_file: null,
        is_tunisian: true,
        country: null,
        adress: null,
        city: null,
        postal_code: null,
        type: this.type
      },
      genderList: [
        { name: "Homme", value: "1" },
        { name: "Femme", value: "2" }
      ],
      qualityList: [
        {
          name: "Actionnaire",
          value: "shareholder"
        },
        {
          name: "Co-fondateur",
          value: "co-founder"
        }
      ],
      isCreated: false,
      app: {}
    };
  },
  methods: {
    submitInvestor() {
      window.scrollTo(0, 0);
      this.$Progress.start();
      this.inProgress = true;
      if (this.form.passeport_number && !this.form.is_tunisian) {
        this.form.cin_number = this.form.passeport_number;
      }
      if (this.form.passeport_file && !this.form.is_tunisian) {
        this.form.cin_file = this.form.passeport_file;
      }
      let investorForm = Object.assign({}, this.form);
      if (investorForm.cin_file) investorForm.cin_file = this.form.cin_file.id;
      if (typeof this.fileUpload[0] != "undefined")
        investorForm.cin_file = this.fileUpload[0];

      if (typeof this.passportFileUplaod[0] != "undefined") {
        investorForm.passeport_file = this.passportFileUplaod[0];
      }
      investorForm.type = this.type;
      window.scrollTo(0, 0);
      this.$store
        .dispatch(SAVE_INVESTOR_FORM, {
          data: investorForm
        })
        .then(() => {
          if(!this.ecosystemApp.application) {
            return this.createApp("investor");
          } else {
            this.$router.push({
              name: 'sessionlessDeclaration',
              params: {
                app_id:  this.ecosystemApp.application ? this.ecosystemApp.application.hash_id : this.$route.params.ecoAppId,
                appType: this.ecosystemApp.application ? this.ecosystemApp.application.type.toLowerCase() : this.$route.params.appType.toLowerCase()
              }
            });
          }
        })
        .catch(({ response }) => {
          this.$Progress.fail();
          this.inProgress = false;
          if (response) this.errors = response.data.meta.errors;
        });
    },
    createApp(type) {
      if (!this.isCreated) {
        let self = this;
        this.isCreated = true;
        this.$store
          .dispatch(CREATE_ECOSYSTEM_APP, type)
          .then(data => {
            localStorage.setItem("ecosystem", true);
            this.$router.push({
              name: 'sessionlessDeclaration',
              params: {
                ecoAppId: data.data.application.hash_id || data.data.application.id,
                appType: data.data.application.type.toLowerCase()
              }
            });
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    formatRouteName(route) {
      let blocks = route.split("-");
      blocks.forEach(function callback(element, index) {
        blocks[index] = element.charAt(0).toUpperCase() + element.slice(1);
      });
      return blocks.join("");
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    vdropzoneProcessing(file) {
      this.inProgress = true;
    },
    dropzoneSuccess(file, response) {
      if (this.form.is_tunisian) {
        this.form.passeport_file = null;
        this.passportFileUplaod = [];
        this.inProgress = false;
        this.fileUpload.push(response.data.document.id);
        this.form.cin_file = response.data.document;
      } else {
        this.form.cin_file = null;
        this.fileUpload = [];
        this.inProgress = false;
        this.passportFileUplaod.push(response.data.document.id);
        this.form.passeport_file = response.data.document;
        this.passportFileError = false;
      }
    },
    vdropzonePassportRemovedFile(file, error, xhr) {
      if (file.path && !this.form.is_tunisian) {
        this.form.passeport_file = null;
        this.passportFileError = true;
      }
      if (xhr != undefined) {
        let data = JSON.parse(file.xhr.response);
        if (data.meta.status == 200) {
          let index = this.passportFileUplaod.indexOf(data.data.document.id);
          if (index > -1) {
            this.passportFileUplaod.splice(index, 1);
          }
        }
      } else {
        let index = this.passportFileUplaod
          .map(function(x) {
            return x;
          })
          .indexOf(file.id);
        if (index > -1) {
          this.passportFileUplaod.splice(index, 1);
        }
      }
    },
    vdropzoneError(file, message, xhr) {
      if (xhr != undefined) {
        if (message.meta.status == 400) {
          if (this.form.is_tunisian) {
            this.passportFileUplaod.splice(-1, 1);
          } else {
            this.fileUpload.splice(-1, 1);
          }
        }
      }
      this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
        "you cant upload this file";
    },
    vdropzoneRemovedFile(file, error, xhr) {
      if (file.path && this.form.is_tunisian) {
        this.form.cin_file = null;
      }
      if (xhr != undefined) {
        let data = JSON.parse(file.xhr.response);
        if (data.meta.status == 200) {
          let index = this.fileUpload.indexOf(data.data.document.id);
          if (index > -1) {
            this.fileUpload.splice(index, 1);
          }
        }
      } else {
        let index = this.fileUpload
          .map(function(x) {
            return x;
          })
          .indexOf(file.id);
        if (index > -1) {
          this.fileUpload.splice(index, 1);
        }
      }
    },
    validateFieldError(field) {
      const fieldHasError = this.errors.map(e => e.fields[0]).includes(field);
      return fieldHasError;
    },
    getFieldMsgError(field) {
      const errorMsg = this.errors.filter(e => e.fields[0] === field);
      if (errorMsg.length) {
        let res = Array.isArray(errorMsg[0].message)
          ? errorMsg[0].message[0]
          : errorMsg[0].message;
        res =
          res == "Le champ cin number doit contenir 8 chiffres."
            ? "Le champ Cin doit contenir 8 chiffres."
            : res;
        return res;
      }
      return "";
    },
    fromDateGreaterThanToDate(dataSource) {
      return (
        dataSource.to_year &&
        !dataSource.currently_work &&
        dataSource.from_year &&
        new Date(dataSource.from_year) > new Date(dataSource.to_year)
      );
    },
    next() {
      console.log(this.$route.params.ecoAppId);
      this.$router.push({
        name: "sessionlessDeclaration",
        params: {
          app_id: this.ecosystemApp.application ? this.ecosystemApp.application.hash_id : this.$route.params.ecoAppId,
          appType: this.ecosystemApp.application ? this.ecosystemApp.application.type.toLowerCase() : this.$route.params.appType
        }
      });
    }
  },
  created() {
    if (this.formData) {
      this.form = this.formData;
    }
    if(this.application){
      this.app = this.application
    }
  },
  computed: {
    ...mapGetters(["session", "currentUser", "ecosystemApp"])
  },
  watch: {
    "team.cin_number": {
      handler(newVal, oldVal) {
        if (newVal && oldVal && this.form.is_tunisian) {
          this.form.passeport_number = null;
        }
      }
    },
    "team.passeport_number": {
      handler(newVal, oldVal) {
        if (newVal && oldVal && !this.form.is_tunisian) {
          this.form.cin_number = null;
        }
      }
    },
    formData() {
      this.form = this.formData;
    },
    application() {
      this.app = this.application
    }
  },
  beforeDestroy() {}
};
</script>
